module.exports = __webpack_public_path__ + "images/bannerIT-6d08f82b8a5c7847c5b372d737a2032b.png";